import React, { Component } from "react"
import { Grid, GridProps } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledGrid = styled(Grid)`
  margin-top: 0 !important;
  padding-left: 5px !important;
  padding-right: 5px !important;

  &.ui.grid>.row{
     padding-top: 0.5rem !important;
     padding-bottom: 0.5rem !important;
  }
`;

class PraxFormGrid extends Component<GridProps> {

  render(): React.ReactNode {
    const {children, ...rest} = this.props;
    return (
        <StyledGrid {...rest}>
          {children}
        </StyledGrid>
    )
  }
}

export default PraxFormGrid;
